import zh1 from './zh1'
export default {
  route: {
    ...zh1,
    platmanagemtnt: '平台管理',    
    branchlist: '分店清单',
    fabriclist: '面料商清单',
    myaccount:'资金账户',
    designers: '入驻版师清单',
    PLT文件价格: 'PLT文件价格',
    '模板内容': '模板内容',
    '管理员': '管理员',
    '确定要删除当前视频吗?': '确定要删除当前视频吗?',
    '地址': '地址',
    '播放终端': '播放终端',
    '指定位置': '指定位置',
    '升级会员处': '升级会员处',
    '未指定': '未指定',
    '标题:': '标题:',
    '请录入视频标题!': '请录入视频标题!',
    '请录入视频标题': '请录入视频标题',
    '分类:': '分类:',
    '请选择视频分类!': '请选择视频分类!',
    '视频地址:': '视频地址:',
    '封面图片:': '封面图片:',
    '播放终端:': '播放终端:',
    '指定位置:': '指定位置:',
    '排序:': '排序:',
    '请录入视频地址或点击浏览上传视频!': '请录入视频地址或点击浏览上传视频!',
    '请上传视频封面图片!': '请上传视频封面图片!',
    '请选择播放终端!': '请选择播放终端!',
    '请录入排序值!': '请录入排序值!',
    '平台客户': '平台客户',
    '分店客户': '分店客户',
    '面料商客户': '面料商客户',
    '成衣生产商客户': '成衣生产商客户',
    '新增视频文件': '新增视频文件',
    '分类名称': '分类名称',
    '新增分类': '新增分类',
    '新增视频分类': '新增视频分类',
    '录入分类名称': '录入分类名称',
    '用户名密码登录': '用户名密码登录',
    '用户名/手机号码': '用户名/手机号码',
    '密码': '密码',
    '记住账号': '记住账号',
    '忘记密码': '忘记密码',
    '登录': '登录',
    '手机验证码登录': '手机验证码登录',
    '输入手机号码': '输入手机号码',
    '输入验证码': '输入验证码',
    '微信扫码登录': '微信扫码登录',
    '绑定手机号': '绑定手机号',
    '请录入11位手机号码': '请录入11位手机号码',
    '请录入手机号码': '请录入手机号码',
    '请录入6位短信验证码': '请录入6位短信验证码',
    '店面未激活，请等待激活后再登录！': '店面未激活，请等待激活后再登录！',
    '店面已关闭，如需开通，请联系管理员处理！': '店面已关闭，如需开通，请联系管理员处理！',
    '店面已锁定，请联系管理员处理！': '店面已锁定，请联系管理员处理！',
    '绑定成功,并自动完成登录。': '绑定成功,并自动完成登录。',
    '请输入正确的验证码': '请输入正确的验证码',
    '请输入正确的手机号': '请输入正确的手机号',
    '获取验证码失败': '获取验证码失败',
    '手机号码未注册': '手机号码未注册',
    '请录入正确的手机号码！': '请录入正确的手机号码！',
    '输入参数名称开始检索': '输入参数名称开始检索',
    '参数名称': '参数名称',
    '参数说明': '参数说明',
    '参数值': '参数值',
    '最后修改时间': '最后修改时间',
    '制版师回复使用模板': '制版师回复使用模板',
    '客户回复使用模板': '客户回复使用模板',
    '开通线下支付': '开通线下支付',
    '开通支付宝支付': '开通支付宝支付',
    '件': '件',
    '折': '折',
    '点击查看发货人': '点击查看发货人',
    '点击查看模板内容': '点击查看模板内容',
    '点击查看/编辑账号信息': '点击查看/编辑账号信息',
    '例：四川省成都市清羊区成明路423号': '例：四川省成都市清羊区成明路423号',
    '例：张三': '例：张三',
    '例：18930888888': '例：18930888888',
    '编辑收款账号信息': '编辑收款账号信息',
    '开户名称:': '开户名称:',
    '请录入开户名称!': '请录入开户名称!',
    '银行地址:': '银行地址:',
    '请录入开户银行!': '请录入开户银行!',
    '开户账号:': '开户账号:',
    '请录入开户账号!': '请录入开户账号!',
    '短信验证:': '短信验证:',
    '请录入验证码!': '请录入验证码!',
    '发送验证码': '发送验证码',
    '发送至': '发送至',
    '验证码不正确': '验证码不正确',
    '资产信息': '资产信息',
    '可提现额度：': '可提现额度：',
    '账户总额度：': '账户总额度：',
    '今日入账-￥': '今日入账-￥',
    '不可提现': '不可提现',
    '未提现': '未提现',
    '历史入账-￥': '历史入账-￥',
    '入账时间：': '入账时间：',
    '已收款': '已收款',
    '历史提现': '历史提现',
    '收款信息': '收款信息',
    '开户行:': '开户行:',
    '请录入银行名称如：中国银行!': '请录入银行名称如：中国银行!',
    '请录入银行名称如：中国银行': '请录入银行名称如：中国银行',
    '账号名称:': '账号名称:',
    '请录入持卡人名称!': '请录入持卡人名称!',
    '请录入持卡人名称': '请录入持卡人名称',
    '银行卡号:': '银行卡号:',
    '请录入银行卡号!': '请录入银行卡号!',
    '请录入银行卡号': '请录入银行卡号',
    '可提现额度': '可提现额度',
    '提现金额必须大于0': '提现金额必须大于0',
    '提现申请成功': '提现申请成功',
    '还没有设置提现账号，请先设置提款账号后再提现。': '还没有设置提现账号，请先设置提款账号后再提现。',
    '订单客户': '订单客户',
    '入账原由': '入账原由',
    '收退款': '收退款',
    '提现完结时间': '提现完结时间',
    '发货人信息': '发货人信息',
    '发货人姓名:': '发货人姓名:',
    '请录入发货人姓名!': '请录入发货人姓名!',
    '发货人电话:': '发货人电话:',
    '请录入发货人电话!': '请录入发货人电话!',
    '公司名称:': '公司名称:',
    '请录入公司名称!': '请录入公司名称!',
    '发货地邮编:': '发货地邮编:',
    '请录入发货地邮编!': '请录入发货地邮编!',
    '发货地省:': '发货地省:',
    '请录入发货地省!': '请录入发货地省!',
    '发货地市:': '发货地市:',
    '请录入发货地市!': '请录入发货地市!',
    '发货地县:': '发货地县:',
    '请录入发货地县!': '请录入发货地县!',
    '详细地址:': '详细地址:',
    '请录入详细地址!': '请录入详细地址!',
    '当前您的帐号未绑定手机号为了保障您的权益,': '当前您的帐号未绑定手机号为了保障您的权益,',
    '请务必绑定手机号': '请务必绑定手机号',
    '输入视频标题检索': '输入视频标题检索',
    ...zh1
  },
}
